// Consent-gated GA4 event stubs.
// No analytics or marketing script loads before its category is granted.
// A real GA4 Measurement ID can be supplied later via REACT_APP_GA4_ID.

let analyticsGranted = false;
let marketingGranted = false;
let gaLoaded = false;

const GA_ID = process.env.REACT_APP_GA4_ID;

function loadGA() {
  // Gated: load only when analytics consent is granted AND an ID exists.
  if (gaLoaded || !analyticsGranted || !GA_ID) return;
  gaLoaded = true;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { anonymize_ip: true });
}

export function setAnalyticsConsent(granted) {
  analyticsGranted = !!granted;
  if (analyticsGranted) loadGA();
}

export function setMarketingConsent(granted) {
  marketingGranted = !!granted;
  // Marketing scripts would load here once a provider and consent exist.
}

// Central event tracker. Silently no-ops before analytics consent is granted.
export function track(event, params = {}) {
  if (!analyticsGranted) return;
  if (window.gtag) {
    window.gtag("event", event, params);
  } else if (process.env.NODE_ENV !== "production") {
    // Stub visibility while no GA4 ID is configured.
    console.debug("[ga4 stub]", event, params);
  }
}

// Named helpers for the required events.
export const trackCta = (location) => track("cta_click", { location });
export const trackCalculator = (name) => track("calculator_used", { calculator: name });
export const trackFormSubmit = (form) => track("form_submit", { form });
export const trackFaqOpen = (question) => track("faq_open", { question });
